import type { ITableHeaderFields } from '.';

export const fullTableHeaders: ITableHeaderFields[] = [
	{ label: 'Agreement' },
	{ label: 'Telematic Solution' },
	{ label: 'Signed Date' },
	{ label: 'Expiration Date' },
	{ label: 'Status' },
];

export const partialTableHeaders = [
	{ label: 'Agreement' },
	{ label: 'Telematic Solution' },
	{ label: 'Fleet Company Name' },
];
